<div class="sd-container--variant-white" [ngClass]="{'sd-container' : userFundsSelectionVisible}">
  @if ((blueprint | apiError)?.()) {
    <rpt-element-error [error]="(blueprint | apiError)()" />
  } @else if (blueprint()) {
    @for (component of blueprint()?.components; track component.documentId) {
      <wct-blueprint-component
        [component]="component"
        [border]="!$first" />
    }

    <sd-4-5-1-tab-group
      #activeTabs="activeTabs"
      wctActiveTab
      [initialTab]="blueprint().tabs[0] | tabIdentifier"
      (sd-tab-show)="activeTabs.handleTabShowEvent($event); dokaVisible.set(activeTabs.activeTab() === tabDoka)">

      @for (tab of blueprint().tabs; track tab.name) {
        <sd-4-5-1-tab
          slot="nav"
          panel="{{ tab | tabIdentifier }}"
          variant="container">
          {{ tab.name }}
        </sd-4-5-1-tab>
        <sd-4-5-1-tab-panel
          name="{{ tab | tabIdentifier }}">

          @for (component of tab.components; track component.documentId) {
            <wct-blueprint-component [component]="component" />
          } @empty {
            <span>{{ 'fundportrait.noElementsMessage' | transloco }}</span>
          }

        </sd-4-5-1-tab-panel>
      }

      <sd-4-5-1-tab
        slot="nav"
        panel="{{ tabSustainability }}"
        variant="container">
        {{ 'fundportrait.sustainabilityTab' | transloco }}
      </sd-4-5-1-tab>
      <sd-4-5-1-tab-panel
        name="{{ tabSustainability }}"
        class="compact">
        <div class="sd-headline sd-headline--size-3xl">{{ 'fundportrait.sustainability' | transloco }}</div>
        <wct-doka [dokaOptions]="sustainabilityOptions" />
      </sd-4-5-1-tab-panel>

      <sd-4-5-1-tab
        slot="nav"
        panel="{{ tabDoka }}"
        variant="container">
        {{ 'fundportrait.doka' | transloco }}
      </sd-4-5-1-tab>
      <sd-4-5-1-tab-panel name="{{ tabDoka }}" class="compact">
        @if (dokaVisible()) {
          @if (userFundsSelectionVisible) {
            <wct-doka [dokaOptions]="dokaOptions" />
          } @else {
            <wct-doka [dokaOptions]="dokaOptionsPrelogon" />
          }
        }
      </sd-4-5-1-tab-panel>
    </sd-4-5-1-tab-group>
  }
</div>
